"use client";
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { NotificationService } from "../../../service/NotificationService";
import { AppDispatch } from "../../../feature/store/store";
import { requestPasswordResetApi } from "../../../feature/reducers/userSlice";
import { inputClass, labelClass, errorClass, buttonClass, errorText } from "./style";

interface EmailFormProps {
  onNextStep: () => void;
  setEmail: (email: string) => void;
}

const EmailForm: React.FC<EmailFormProps> = ({ onNextStep, setEmail }) => {
  const dispatch = useDispatch<AppDispatch>();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().trim().email("Ungültige E-Mail-Adresse").required("E-Mail ist erforderlich"),
    }),
    onSubmit: async (values) => {
      const email = values.email.trim();
      try {
        await dispatch(requestPasswordResetApi(email)).unwrap();
        NotificationService.success("Code wurde an Ihre E-Mail gesendet.");
        setEmail(email);
        onNextStep();
      } catch (error: any) {
        NotificationService.error(errorText(error, "Code konnte nicht gesendet werden."));
      }
    },
  });

  const error = formik.touched.email && formik.errors.email;

  return (
    <form onSubmit={formik.handleSubmit} noValidate className="flex flex-col gap-5">
      <p className="text-[15px] leading-relaxed text-ao-muted">
        Geben Sie die E-Mail-Adresse Ihres Kontos ein. Wir schicken Ihnen einen 6-stelligen Code.
      </p>

      <div className="flex flex-col gap-2">
        <label htmlFor="email" className={labelClass}>E-Mail</label>
        <input
          type="email"
          id="email"
          name="email"
          autoComplete="email"
          placeholder="ihre@email.de"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          aria-invalid={!!error}
          className={`${inputClass} ${error ? "border-red-500" : "border-ao-line-strong"}`}
        />
        {error && <p className={errorClass}>{formik.errors.email}</p>}
      </div>

      <button type="submit" disabled={formik.isSubmitting} className={buttonClass}>
        {formik.isSubmitting ? "Wird gesendet…" : "Code senden"}
      </button>
    </form>
  );
};

export default EmailForm;
